import { useState, useCallback } from 'react';
import { message } from 'antd';
import {
  c305Api,
  QueryParams,
  CustomerStatRow,
  ProductStatRow,
  DeptStatRow,
  SalesCustomerStatRow,
  CurrencySummary,
  UnitSummary,
  CustomerQueryResponse,
  ProductQueryResponse,
  DeptQueryResponse,
  SalesCustomerQueryResponse,
} from '../../../services/c305Api';

export function useC305Query() {
  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState<CustomerStatRow[]>([]);
  const [productData, setProductData] = useState<ProductStatRow[]>([]);
  const [deptData, setDeptData] = useState<DeptStatRow[]>([]);
  const [salesCustomerData, setSalesCustomerData] = useState<SalesCustomerStatRow[]>([]);
  const [currencySummary, setCurrencySummary] = useState<CurrencySummary[]>([]);
  const [unitSummary, setUnitSummary] = useState<UnitSummary[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);
  const [currentType, setCurrentType] = useState<string>('order_customer');

  const clearAll = useCallback(() => {
    setCustomerData([]);
    setProductData([]);
    setDeptData([]);
    setSalesCustomerData([]);
    setCurrencySummary([]);
    setUnitSummary([]);
  }, []);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await c305Api.query(params);
      const type = params.report_type || 'order_customer';
      setCurrentType(type);
      clearAll();

      const hasData = resp.data && resp.data.length > 0;

      if (!hasData) {
        setNoData(true);
        message.info((resp as { message?: string }).message || '查無此資料!');
      } else {
        if (type === 'product') {
          const r = resp as ProductQueryResponse;
          setProductData(r.data);
          setUnitSummary(r.unit_summary || []);
        } else if (type === 'department') {
          const r = resp as DeptQueryResponse;
          setDeptData(r.data);
          setCurrencySummary(r.currency_summary || []);
        } else if (type === 'sales_customer') {
          const r = resp as SalesCustomerQueryResponse;
          setSalesCustomerData(r.data);
          setCurrencySummary(r.currency_summary || []);
        } else {
          const r = resp as CustomerQueryResponse;
          setCustomerData(r.data);
          setCurrencySummary(r.currency_summary || []);
        }
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, [clearAll]);

  const reset = useCallback(() => {
    clearAll();
    setQueried(false);
    setNoData(false);
  }, [clearAll]);

  return {
    loading, customerData, productData, deptData, salesCustomerData,
    currencySummary, unitSummary, queried, noData, currentType,
    runQuery, reset,
  };
}
